export function convertNumberToMillions(value: number): number {
  return Math.round((value / 1000000) * 100) / 100;
}

export function convertNumberToThousands(value: number): number {
  return Math.round((value / 1000) * 10) / 10;
}
